<template>
	<v-form @keydown.enter.prevent>
		<v-container v-if="isEdit">
			<v-layout row wrap>
				<v-flex xs12>
					<v-subheader class="pl-0 mb-4 text-xs-left">
						Hiding an employee from the Employee Directory will prevent the employee from showing up in any reports, searches, or selections. This setting is designed for external users who require a login only.
					</v-subheader>
					<v-checkbox ref="defaultFocusElement" v-model="value.hideFromEmployeeDirectory" label="Hide from Employee Directory"> </v-checkbox>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container v-else>
			<v-layout row wrap>
                <v-flex xs12>
					<v-subheader class="pl-0 mb-4 text-xs-left">
						Hiding an employee from the Employee Directory will prevent the employee from showing up in any reports, searches, or selections. This setting is designed for external users who require a login only.
					</v-subheader>
					<v-checkbox v-model="value.hideFromEmployeeDirectory" label="Hide from Employee Directory" disabled> </v-checkbox>
				</v-flex>
			</v-layout>
		</v-container>
	</v-form>
</template>

<script>
	import formMixin from '@/mixins/employeeFormMixin';

	export default {
		mixins: [formMixin]
	};
</script>
